import goTo from '../goTo'
import { deprecate } from '../../../util/console'

deprecate('vuetify/es5/components/Vuetify/util/goTo', 'vuetify/es5/components/Vuetify/goTo')

export default goTo
